import { Box, Button, DialogContent, keyframes, Typography } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import GlobalDialogContent from '../GlobalDialogContent';
import { useState } from 'react';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "../../../redux/store";
import { TPMGenerateMou } from '../../../utils/services/tri-party-mou/tri.party.mou.service';

const TPMGenerateMOU = () => {
    const [buttonLoader, setButtonLoader] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const payload = useSelector((state: RootState) => state.dialog.payload);
    const dispatch = useDispatch();

    const handleSubbmit = async () => {
        setButtonLoader(true);
        try {
            const { code, data, message } = await TPMGenerateMou({ uuid: payload.uuid });
            setButtonLoader(false);
            if (code === 200) {

                dispatch(showSnackbar({ type: 'success', message: message || 'Documents uploaded successfully.' }));
                dispatch(setModuleRefresh({ moduleName: 'mouUpload', refresh: true }));
                dispatch(closeDialog());
            } else {
                dispatch(showSnackbar({ type: 'error', message: message || 'Document upload failed.' }));
            }
        } catch (error) {
            dispatch(showSnackbar({ type: 'error', message: 'An error occurred during upload.' }));
        } finally {
            setButtonLoader(false);

            setIsUploading(false);
        }
    }



    const floatAnimation = keyframes`
      0% { transform: translateY(0px); }
      50% { transform: translateY(-8px); }
      100% { transform: translateY(0px); }
    `;


    return (
        <Box sx={{ bgcolor: 'background.default' }}>
            <GlobalDialogContent
                dialogBody={
                    <>
                        <DialogContent sx={{ p: 1 }}>
                            <Box sx={{ display: 'flex', textAlign: 'left', }}>
                                <Box sx={{ animation: `${floatAnimation} 3s ease-in-out infinite`, }}>
                                    <img src="/common/interested.png" alt="Interested in Project Icon" width="100" height="100" style={{ filter: "drop-shadow(3px 5px 1px rgba(0,0,0,0.3))" }} />
                                </Box>
                                <Typography variant="h5" sx={{ textAlign: 'center ', pl: 5, pt: 2 }}>
                                    Are you really want to Generate Tri Party MOU for {payload.title}?
                                </Typography>
                            </Box>
                        </DialogContent>
                    </>
                }
                dialogFooter={
                    <Button
                        disabled={buttonLoader || isUploading}
                        onClick={() => handleSubbmit()}
                        type="submit"
                        variant="contained"
                        color="success"
                        endIcon={<CheckCircleOutline />}
                    >
                        {isUploading ? 'Generating...' : 'Generate MOU'}
                    </Button>
                }
            />
        </Box>
    );
};

export default TPMGenerateMOU;